import { render, staticRenderFns } from "./AthleteMindsetReport.vue?vue&type=template&id=3d97917e&scoped=true&"
import script from "./AthleteMindsetReport.vue?vue&type=script&lang=ts&"
export * from "./AthleteMindsetReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d97917e",
  null
  
)

export default component.exports